import React, { useEffect, useState } from 'react';

const API_BASE = '/api/user/auth';

async function postJson(url: string, body: any) {
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const ct = res.headers.get('content-type') || '';
    const parse = async () => (ct.includes('application/json') ? res.json() : { message: await res.text() });
    const data = await parse();
    if (!res.ok) throw new Error((data && (data.message || data.error)) || `Fehler (${res.status})`);
    return data;
}

export default function ResetPasswordPage() {
    const usp = new URLSearchParams(window.location.search);
    const initialEmail = usp.get('email') || '';
    const initialToken = usp.get('token') || '';

    const [email, setEmail] = useState(initialEmail);
    const [token, setToken] = useState(initialToken);
    const [pw1, setPw1] = useState('');
    const [pw2, setPw2] = useState('');
    const [msg, setMsg] = useState<string | null>(null);
    const [err, setErr] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    // Redirect-Status + Countdown
    const [ok, setOk] = useState(false);
    const [seconds, setSeconds] = useState(3);

    useEffect(() => {
        if (!ok) return;
        const tick = setInterval(() => setSeconds(s => (s > 0 ? s - 1 : 0)), 1000);
        const to = setTimeout(() => {
            window.location.replace('/');
        }, 3000);
        return () => {
            clearInterval(tick);
            clearTimeout(to);
        };
    }, [ok]);

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErr(null);
        setMsg(null);

        if (pw1.length < 8) return setErr('Das neue Passwort muss mindestens 8 Zeichen haben.');
        if (pw1 !== pw2) return setErr('Die Passwörter stimmen nicht überein.');

        setLoading(true);
        try {
            const data = await postJson(`${API_BASE}/reset-password`, { email, token, newPassword: pw1 });
            setMsg(data.message || 'Passwort erfolgreich geändert.');
            setPw1(''); setPw2('');
            setOk(true);          // Auto-Redirect starten
            setSeconds(3);        // Countdown zurücksetzen
        } catch (e: any) {
            setErr(e.message || 'Zurücksetzen fehlgeschlagen');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow p-6">
                <h1 className="text-xl font-semibold mb-4">Neues Passwort setzen</h1>

                <form onSubmit={submit} className="space-y-3">
                    <input
                        type="email"
                        className="w-full border px-3 py-2 rounded"
                        placeholder="E-Mail"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                    />

                    {/* Token unsichtbar halten */}
                    <input
                        type="hidden"
                        value={token}
                        onChange={e => setToken(e.target.value)}
                    />

                    <input
                        type="password"
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Neues Passwort (min. 8 Zeichen)"
                        value={pw1}
                        onChange={e => setPw1(e.target.value)}
                        required
                        minLength={8}
                        autoComplete="new-password"
                    />
                    <input
                        type="password"
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Neues Passwort wiederholen"
                        value={pw2}
                        onChange={e => setPw2(e.target.value)}
                        required
                        minLength={8}
                        autoComplete="new-password"
                    />

                    {err && <div className="text-red-600 text-sm">{err}</div>}
                    {msg && (
                        <div className="text-green-700 text-sm">
                            {msg}{' '}
                            {ok && (
                                <>
                                    – du wirst in {seconds} Sekunden automatisch weitergeleitet.
                                    {' '}<a href="/" className="text-blue-600 underline">Jetzt weiter</a>
                                </>
                            )}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-blue-600 text-white w-full py-2 rounded disabled:opacity-60"
                    >
                        {loading ? 'Bitte warten…' : 'Passwort setzen'}
                    </button>
                </form>
            </div>
        </div>
    );
}
